import { format, secondsToMinutes } from 'date-fns';

export function formatQuizTime(time: number | null | undefined): string {
  return time ? `${secondsToMinutes(time)} min` : 'Bez limitu';
}

export function formatQuizPoints(points: number, opts?: { withUnit?: boolean }): string {
  return opts?.withUnit ? `${points} pkt` : `${points}`;
}

export function formatQuizMaxAttempts(maxAttempts: number, opts?: { withUnit?: boolean }): string {
  if (maxAttempts === 0) {
    return opts?.withUnit ? 'Bez limitu podejść' : 'Bez limitu';
  }
  return opts?.withUnit ? `${maxAttempts} podejść` : `${maxAttempts}`;
}

export function formatQuizDeadline(deadline: string | null | undefined, opts?: { withTime?: boolean; fallback?: string }): string {
  if (!deadline) return opts?.fallback ?? 'Brak terminu';
  return format(new Date(deadline), opts?.withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy');
}

export function formatQuizAvailable(available: string | null | undefined): string {
  return available ? format(new Date(available), 'dd.MM.yyyy HH:mm') : 'Od razu';
}
